import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
* {
  margin: 0;
  padding: 0;
  box-sizing: content-box;
}

body {
  font-family: ${({ theme }) => theme.fonts.primary};
  overflow-x: hidden;
  background: ${({ theme }) => theme.base.black};
  #ccm_notification {
    z-index: 9999999999!important;
  }
}

.gigya-screen {
  width: auto !important;
  margin: 0 !important;
}

a { text-decoration: none;}

`;

const Section = styled.section`
  background: ${({ pageWithBackgroundColor, theme }) =>
    pageWithBackgroundColor ? theme.base.white : theme.tertiary.light};
  min-height: 100vh;
`;

export default Section;
